import { t } from 'i18next';

/**
 * usePaymentTypeCountMessage
 *
 * A custom React hook that returns a label based on the number of selected payment types.
 * The label adapts between singular and plural forms depending on the `count`.
 * When `count` is 0, it still uses the singular form (e.g., "Payment type") for better UX.
 *
 * This is useful for displaying dynamic, localized UI text that reflects selection count,
 * using a provided `paymentType` object containing correct word forms.
 *
 * @param count - The number of selected payment types (0 or more)
 * @param paymentType - An object that holds the singular and plural forms of the label
 *
 * @returns A string label appropriate for the given count.
 */

function usePaymentTypeCountMessage() {
  return (count: number): string => {
    
    const paymentType = t('statisticPage.header.filter.paymentType', {
      returnObjects: true,
    }) as any;

    const label =
      count === 0 || count === 1 ? (paymentType?.nominative?.singular ?? '') : (paymentType?.nominative?.plural ?? '');

    return `${label}`;
  };
}

export default usePaymentTypeCountMessage;
